// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"472cff06","732":"4cccbb40","977":"72e92564"}[chunkId] + ".chunk.js");